import { Injectable } from "@angular/core";
import { FilterFlowSecAdapter } from "../data/adapters/filter.flowsec.adapter";
import { FilterUserAdapter } from "../data/adapters/filter.user.adapter";
import { GroupbyUserAdapter } from "../data/adapters/groupby.user.adapter";
import { GroupbyFlowSecAdapter } from "../data/adapters/groupby.flowsec.adapter";
import { QueryExpressionParserService } from "@nrwl/query-emitter";
import { ValueAdapterProvider } from "@nrwl/query-emitter";
import { ValueAdapter } from "@nrwl/query-emitter";
import { FilterAnomalyAdapter } from "../data/adapters/filter.anomaly.adapter";

@Injectable()
/**
 * Different NitroDB data models might have different column names.
 * This class allows to connect widget JSON config with specific piece of logic in javascript.
 *
 * Widget config will refer to specific adapter via value_adapter parameter on input definition.
 * See this example:
 * {
    "id":"filter",
    "value": "inputs.fuzzy_filter.expression",
    "value_adapter": {"name": "build_filter_flowsec", "config": {"direction":"incoming"}}
   },
   {
    "id":"groupby",
    "value": "inputs.fuzzy_filter.expression",
    "value_adapter": {"name": "build_groupby_flowsec", "config": {"direction":"incoming"}}
   }
  And then, query template looks like this:
   ...
   "groupby": "${groupBy('app')}",
   "postFilter": "${filter}",
   ...
  The same input parameter (expression from fuzzy search input) is transformed 2 times:
  - as SQL where condition (site2 = 'Boston' AND ....) to be injected into query 'filter'.
  - as comma separated list of field names, to be added to groupby. See the example above, that explains how to populate
    groupby field dynamically. First, we call the function 'groupBy' and pass over the list of fields to be present in groupby
    (for example, you want to see data grouped by app name). The function 'groupBy' internally seeks parameter named 'groupby'
    and concatenates value of that parameter with static list, passed directly to  groupBy function.
    Yes, I know this is ugly and very weird. However this is the only way now to make query accepted by backend.

 */
export class PtcValueAdapterProvider extends ValueAdapterProvider {
  queryBuilder;
  constructor(queryBuilder: QueryExpressionParserService) {
    super();
    this.queryBuilder = queryBuilder;
  }

  // sample config: {"name": "build_groupby_flowsec_incoming", "config": {"direction":"incoming"}}
  getPostprocessor(config):ValueAdapter {
    switch (config.name) {
      case 'build_filter_flowsec':
      case 'build_filter_apa':
        return new FilterFlowSecAdapter(this.queryBuilder, config.config);
      case 'build_filter_user':
        return new FilterUserAdapter(this.queryBuilder, config.config);
      case 'build_anomaly_filter':
        return new FilterAnomalyAdapter(this.queryBuilder);
      case 'build_groupby_flowsec':
      case 'build_groupby_apa':
        return new GroupbyFlowSecAdapter(config.config);
      case 'build_groupby_user':
        return new GroupbyUserAdapter(config.config);
      default: {
        console.error('Unknown adapter config name', config.name);
      }
    }
    return null;
  }
}
